import React from 'react';
import Row from "./Row";

const CheckTermsAndCondition = ({value, onChange, className}) => {

    const handleChange = (e) => {
        onChange && onChange(e.target.checked);
    }

    return (
        <Row className={`gap-1 items-center ${className}`}>
            <input type="checkbox" value={value} onChange={handleChange}/>
            <div>Conferma la lettura dei</div>
            <a href={process.env.REACT_APP_TERMS_AND_CONDITIONS} target="_blank"
               className="hover:underline cursor-pointer">Termini e delle Condizioni</a>
        </Row>
    );
};

export default CheckTermsAndCondition;
